// resume page/component
import { useContext, useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useParams, Link } from "react-router-dom";
import axios from 'axios';

import StateContext from '../stateContext';

import Menu from './footer';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

function Resume() {

  const { appID, resumeFormat } = useParams();

  const { globalAppStatus, setGlobalAppStatus, createNotification, applicationStati, userInfo, setGlobalHeader} = useContext(StateContext);
  const [pdfUrl, setPdfURL] = useState();
  const [resumeTrigger, setResumeTrigger] = useState(true);
  const [pdfJSON, setPDFJSON] = useState(undefined);
  const [resumeJSON, setResumeJSON] = useState(undefined)
  const [isValidJSON, setIsValidJSON] = useState(true);
  const [curView, setCurView] = useState("pdf");

  // determine resume format
  var foundResFormat = undefined;

  if (resumeFormat != undefined) {
    foundResFormat = resumeFormat;
  } else if (typeof(userInfo.default_resume_format) == "number" && userInfo.default_resume_format > 0) {
    foundResFormat = userInfo.default_resume_format;
  } else {
    foundResFormat = 1;
  }

  // download resume
  useEffect(() => {

    if (appID == undefined || appID == "undefined") {
      return;
    }

    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    setGlobalHeader(`Resume`) 

    axios.post(
      '/api/resume/download',
    {
      "email": userInfo.email,
      "jwt": userInfo.jwt,
      "application_id": appID,
      "resume_format": foundResFormat
    },
    {
      responseType: 'arraybuffer',
      headers: {
        'Accept': 'application/pdf'
      }
    }
    ).then((response) => {
      if (response.status != 200) {
        createNotification({
          "status": "error",
          "msg": "Error downloading resume",
        }) 
      } else if (response.status === 200 && response.data){
        // 1. Convert the ArrayBuffer directly into a PDF Blob
        const blob = new Blob([response.data], { type: 'application/pdf' });

        // 2. Generate a temporary browser URL pointing to that Blob in memory
        const tmppdfUrl = URL.createObjectURL(blob);
        setPdfURL(tmppdfUrl);
      } else {
        // handle all other response types, txt/html...etc   
        createNotification({
          "status": "error",
          "msg": "Unexpected return type found.",
        })
      }
    }).catch(() => {
      createNotification({
        "status": "error",
        "msg": "Failed to fetch resume binary.",
      });
    });
  }, [resumeTrigger, resumeFormat, appID]);

  // download resume json
  useEffect(() => {

    if (appID == undefined || appID == "undefined") {
      return;
    }

    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post(
      '/api/resume/download',
    {
      "email": userInfo.email,
      "jwt": userInfo.jwt,
      "application_id": appID,
      "resume_type": "json",
      "resume_format": foundResFormat
    }
    ).then((response) => {
      if (response.status == 200 && response.data.success == true) {
          setPDFJSON(JSON.stringify(response.data.result, null, 2));
          setResumeJSON(response.data.result);
          
          if (response.data.result.company_name != undefined) {
            setGlobalHeader({
              href: response.data.result.link,
              anchor: `Resume: ${response.data.result.company_name}`,
              target: "_blank"
            })
          } else {
            setGlobalHeader(`Resume`)
          }
        } else {

          // prompt error 
          createNotification({
            "status": "error",
            "msg": "Error downloading resume",
          })
        }
      }
    )
  }, [resumeFormat, appID]);

  function saveJSON() {
    // test json string 
    try {
    
    } catch(error) {
      createNotification({
        "status": "error",
        "msg": `JSON Error: ${error.message}`,
      })
    }

    // parse json string to object
    var pJSON = undefined;
    try {
      pJSON = JSON.parse(pdfJSON)
    } catch (error) {
      createNotification({
        "status": "error",
        "msg": "Error updating resume",
      })
    }
      
    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    // rerender resume from saved json
    axios.post(
      '/api/resume/update',
    {
      "email": userInfo.email,
      "jwt": userInfo.jwt,
      "application_id": appID,
      "resume_json": pJSON, 
      "resume_format": foundResFormat
    }
    ).then((response) => {
      if (response.status != 200) {
        createNotification({
          "status": "error",
          "msg": "Error downloading resume",
        }) 
      } else {
        if (response.data.success == true) {
          // retrigger resume reload
          setResumeTrigger(!resumeTrigger);

          // notify user
          createNotification({
            "status": "success",
            "msg": "Resume JSON Updated!",
          })
        } else {
          // prompt error 
          createNotification({
            "status": "error",
            "msg": "Error downloading resume",
          })
        }
      }
    })
  }

  async function downloadResume() {

    if (!pdfUrl) return;

    const link = document.createElement('a');
    link.href = pdfUrl;
    var capCompanyName = resumeJSON.company_name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('_');   
    link.download = `${capCompanyName}_${resumeJSON.job_title.replaceAll(" ", "_")}_${userInfo.fullname_initials}`
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  function toggleView(view) {
    if (curView != view) {
      setCurView(view);
    }
  }

  function updateJSONText(newJSON) {
    
    try {
      JSON.parse(newJSON)
      setIsValidJSON(true)
    } catch (error) {
      setIsValidJSON(false)
    }

    // test updated json
    setPDFJSON(newJSON)
  }

  return (
    <main
      style={ curView == "pdf" ? 
        {
          display: "grid", gridTemplateColumns: "auto minmax(min-content, max-content) minmax(200px, 800px) minmax(min-content, max-content) auto", 
          gridTemplateRows: "30px minmax(0, max-content) auto",
          gridTemplateAreas: 
          `". topLeftBtn fmtChangeBtn topRightBtn ."
          ". previousFmtBtn previousFmtBtn previousFmtBtn ."
          ". resumeContent resumeContent resumeContent ."`
        }
      :
        {
          display: "grid", gridTemplateColumns: "auto 100px minmax(100px, 800px) 100px auto", 
          gridTemplateRows: "minmax(0, max-content) minmax(0, max-content) 80% minmax(0, max-content)",
          gridTemplateAreas: 
          `". topLeftBtn fmtChangeBtn topRightBtn ."
          ". previousFmtBtn previousFmtBtn previousFmtBtn ."
          ". resumeContent resumeContent resumeContent ."`
        }
      }
    >
      { curView == "pdf" ? 
        <>
          <button 
            style={{
              gridArea: "topLeftBtn", display: "flex", gap: "5px", 
              justifyContent: "center", alignItems: "center",
              padding: "5px 10px"
            }} 
            className='submit'
            onClick={() => {downloadResume()}}
            >
            Download
            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 12.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.1198 22 8.79986 22H12.5M14 11H8M10 15H8M16 7H8M15 19L18 22M18 22L21 19M18 22V16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <Link to={`/resume/selectDefault/${appID}`} style={{gridArea: "fmtChangeBtn", textAlign: "center", borderRadius: "5px", padding: "5px"}} className='next'>Change Format</Link>
          <button 
            style={{gridArea: "topRightBtn", display: "flex", gap: "5px", 
              justifyContent: "center", alignItems: "center",
              padding: "5px 10px"
            }}
            className='submit'
            onClick={() => {toggleView("json")}}
          >
            Edit
            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 10L14 6M2.49997 21.5L5.88434 21.124C6.29783 21.078 6.50457 21.055 6.69782 20.9925C6.86926 20.937 7.03242 20.8586 7.18286 20.7594C7.35242 20.6475 7.49951 20.5005 7.7937 20.2063L21 7C22.1046 5.89543 22.1046 4.10457 21 3C19.8954 1.89543 18.1046 1.89543 17 3L3.7937 16.2063C3.49952 16.5005 3.35242 16.6475 3.24061 16.8171C3.1414 16.9676 3.06298 17.1307 3.00748 17.3022C2.94493 17.4954 2.92195 17.7021 2.87601 18.1156L2.49997 21.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </>
        : 
        <>
          <button 
            className='submit'
            style={{gridArea: "topLeftBtn", display: "flex", gap: "5px", 
              justifyContent: "center", alignItems: "center",
              padding: "5px 10px"}} 
            onClick={() => {saveJSON()}}
          >
            Save
            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 3V6.4C7 6.96005 7 7.24008 7.10899 7.45399C7.20487 7.64215 7.35785 7.79513 7.54601 7.89101C7.75992 8 8.03995 8 8.6 8H15.4C15.9601 8 16.2401 8 16.454 7.89101C16.6422 7.79513 16.7951 7.64215 16.891 7.45399C17 7.24008 17 6.96005 17 6.4V4M17 21V14.6C17 14.0399 17 13.7599 16.891 13.546C16.7951 13.3578 16.6422 13.2049 16.454 13.109C16.2401 13 15.9601 13 15.4 13H8.6C8.03995 13 7.75992 13 7.54601 13.109C7.35785 13.2049 7.20487 13.3578 7.10899 13.546C7 13.7599 7 14.0399 7 14.6V21M21 9.32548V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H14.6745C15.1637 3 15.4083 3 15.6385 3.05526C15.8425 3.10425 16.0376 3.18506 16.2166 3.29472C16.4184 3.4184 16.5914 3.59135 16.9373 3.93726L20.0627 7.06274C20.4086 7.40865 20.5816 7.5816 20.7053 7.78343C20.8149 7.96237 20.8957 8.15746 20.9447 8.36154C21 8.59171 21 8.8363 21 9.32548Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>    
          <button 
            className='next'
            style={{gridArea: "topRightBtn", display: "flex", gap: "5px", 
              justifyContent: "center", alignItems: "center",
              padding: "5px 10px"
            }} 
            onClick={() => {toggleView("pdf")}}
          >
            View PDF
            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </>
      }
      { curView == "pdf" ? 
      <div style={{gridArea: "resumeContent", overflowY: "scroll", height: "90%"}}>
        { pdfUrl != undefined ?
        <object
          data={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
          type="application/pdf"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
          >
          {/* Fallback if the browser cannot render PDFs inline */}
          <p>
            Your browser does not support inline PDFs.{' '}
          <a href={pdfUrl} download="resume.pdf">Download PDF instead</a>.
          </p>
        </object>
        : <h1
          style={{width: "100%", "textAlign": "center"}}
        >Loading Resume</h1>
        }
      </div>
      :
      <>
        <textarea name="resumeJson" style={{gridArea: "resumeContent"}} value={pdfJSON} onChange={(e) => {updateJSONText(e.target.value)}}/>
        { !isValidJSON ? <span style={{backgroundColor: "red", width: "calc(100% - 20px)", display: "block", padding: "5px 10px"}}>Invalid JSON</span> : undefined }
      </>
      }
    </main>
  )
}

export default Resume;